export const data: TDataTable = [
  {
    name: "Егор П.",
    stack: "Битрикс, PHP",
    exp: 3,
    busy: 45,
    date: "16 July",
    booking: "adsf",
    rate: 400,
  },
  {
    name: "Дмитрий Л.",
    stack: "Верстка, Senior Frontend Developer, React",
    exp: 2,
    busy: 100,
    date: "Свободен",
    rate: 5000,
  },
  {
    name: "Катя В.",
    stack: "Верстка, WordPress",
    exp: 3,
    busy: 40,
    date: "Свободна",
    rate: 600,
  },
  {
    name: "Никита Д.",
    stack: "LAMP (Linux, Apache, MySQL и PHP), Битрикс, Laravel",
    exp: 5,
    busy: 60,
    date: "31 July",
  },
  {
    name: "Степан Р.",
    stack: "React",
    exp: 4,
    busy: 100,
    date: "31 July",
  },
  {
    name: "Александра Ш.",
    stack: "Фуллстек Laravel + VueJS",
    exp: 4,
    busy: 80,
    date: "31 July",
  },
  {
    name: "Александр П.",
    stack: "Фронтенд-разработка + WordPress",
    exp: 5,
    busy: 60,
    date: "31 July",
  },
  {
    name: "Андрей П.",
    stack: "Фронт на VueJS, Верстка + WordPress",
    exp: 3,
    busy: 60,
    date: "31 July",
  },
  {
    name: "Сергей К.",
    stack: "Java, Kotlin, Swift Team Lead",
    exp: 7,
    busy: 40,
    date: "Свободен",
  },
  {
    name: "Павел Е.",
    stack: "iOS SDK, Objective C, Swift, Xcode, RxSwift, ARKit",
    exp: 5,
    busy: 100,
    date: "31 July",
  },
  {
    name: "Дмитрий Б.",
    stack: "iOS SDK, Objective C, Swift, Xcode, RxSwift, ARKit",
    exp: 4,
    busy: 80,
    date: "16 July",
  },
  {
    name: "Алексей П.",
    stack:
      "Android: Java, Kotlin, Dagger 2, MVP(Moxy), MVVM, Retrofit, RxAndroid",
    exp: 4,
    busy: 40,
    date: "16 July",
  },
  {
    name: "Илья С.",
    stack:
      "Android: Java, Kotlin, Dagger 2, MVP(Moxy), MVVM, Retrofit, RxAndroid, Google AR / VR",
    exp: 5,
    busy: 60,
    date: "16 July",
  },
  {
    name: "Михаил Т.",
    stack: "Senior 1С",
    exp: 15,
    busy: 50,
    date: "Свободен",
  },
  {
    name: "Мария Т.",
    stack: "UX, Figma, Tilda",
    exp: 4,
    busy: 80,
    date: "16 July",
  },
  {
    name: "Тарас В.",
    stack: "UX, Figma, Tilda",
    exp: 3,
    busy: 30,
    date: "Свободен",
  },
  {
    name: "Александр Б.",
    stack: "UX, Figma, Баннеры",
    exp: 5,
    busy: 100,
    date: "16 July",
  },
  {
    name: "Младший Юиксер.",
    stack: "UX, Figma, Tilda",
    exp: 1,
    busy: 20,
    date: "Свободен",
  },
  {
    name: "Сергей Л.",
    stack: "Программирование баннеров под все площадки",
    exp: 5,
    busy: 40,
    date: "Свободен",
  },
  {
    name: "Мариан Л.",
    stack: "3D-анимация",
    Теги: "3D-анимация",
    exp: 5,
    busy: 40,
    date: "Свободен",
  },
  {
    name: "Дарья Р.",
    stack: "Полиграфия",
    exp: 5,
    busy: 40,
    date: "Свободна",
  },
  {
    name: "Павел В.",
    stack: "Презентации",
    exp: 2,
    busy: 20,
    date: "Свободен",
  },
  {
    name: "Евгения Р.",
    stack:
      "Бизнес-аналитик, Ведущий менеджер проектов, Бизнес-требования, ТЗ, прототипы, тайминги",
    Теги: "Бизнес-аналитик, Ведущий менеджер проектов, Бизнес-требования, ТЗ, прототипы, тайминги",
    exp: 6,
    busy: 100,
    date: "31 July",
  },
  {
    name: "Екатерина Л.",
    stack:
      "Менеджер проектов, Бизнес-требования, ТЗ, прототипы, тайминги, оценки",
    exp: 4,
    busy: 60,
    date: "Свободна",
  },
  {
    name: "Айлин С.",
    stack:
      "Менеджер проектов, Бизнес-требования, ТЗ, прототипы, тайминги, оценки",
    exp: 4,
    busy: 60,
    date: "Свободна",
  },
  {
    name: "Грэг П.",
    stack: "Финансы, Маркетинг, Продукт, Стратегия",
    exp: 10,
    busy: 40,
    date: "Свободен",
  },
  {
    name: "Test T.",
    stack: "test1, test2, test3",
    exp: 10,
    busy: "Нов",
    date: "Свободен",
  },
];

export const prepareData = (data: TDataTable): TDataTable => {
  return data.map((el, _, ar) => ({
    ...el,
    rate: el.rate ? el.rate : 200,
    booking: "Бронировать",
  }));
};

export const filledData: TDataTable = prepareData(data);